import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { memo as m } from "react";
import n from "clsx";
import { CloseIcon as _ } from "../../icons/CloseIcon.js";
import { useModalContext as d } from "./ModalContext.js";
import '../../_assets/ModalHeader.CzaCDe_R.css';const u = "_header_1uv0m_44", v = "_noDivider_1uv0m_59", g = "_title_1uv0m_63", L = "_button_1uv0m_83", p = "_icon_1uv0m_99", C = "_center_1uv0m_126", b = "_centerLarge_1uv0m_127", h = "_titleCenterLarge_1uv0m_139", e = {
  header: u,
  noDivider: v,
  title: g,
  button: L,
  icon: p,
  center: C,
  centerLarge: b,
  titleCenterLarge: h
}, f = m(({ children: r, className: c }) => {
  const { mode: o, noCloseButton: i, noDivider: a, onClose: s } = d();
  return /* @__PURE__ */ l(
    "div",
    {
      className: n(
        e.header,
        {
          [e.center]: o === "center",
          [e.centerLarge]: o === "centerLarge",
          [e.noDivider]: a
        },
        c
      ),
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: n(e.title, {
              [e.titleCenterLarge]: o === "centerLarge"
            }),
            children: r
          }
        ),
        !i && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            "aria-label": "close modal button",
            className: e.button,
            onClick: s,
            children: /* @__PURE__ */ t("span", { className: e.icon, children: /* @__PURE__ */ t(_, { size: 24 }) })
          }
        )
      ]
    }
  );
});
f.displayName = "ModalHeader";
export {
  f as ModalHeader
};
